module.exports = __webpack_public_path__ + "static/img/totalEquipment.87f988bb.png";